export enum Constants {
    MinFormQuestions = 5
};

export const QuizThemes = [
    { id: "2", title: "none", value: { primary: '#99B3E1', secondary: '#4F62A3' } },
    { id: "3", title: "none", value: { primary: '#A0ADBD', secondary: '#372E46' } },
    { id: "4", title: "none", value: { primary: '#ACA398', secondary: '#443C51' } },
    { id: "5", title: "none", value: { primary: '#c6b497', secondary: '#34626c' } },
    { id: "7", title: "none", value: { primary: '#f05454', secondary: '#30475e' } }
];

export const QuizIcons = [
    { id: "1", title: "Person", icon: 'male' },
    { id: "2", title: "Games", icon: 'gamepad' },
    { id: "3", title: "Movies", icon: 'film' },
    { id: "4", title: "Science", icon: 'flask' },
    { id: "5", title: "Animals", icon: 'paw' },
    { id: "6", title: "History", icon: 'landmark' },
    { id: "7", title: "Music", icon: 'music' },
    { id: "8", title: "Geography", icon: 'globe-americas' },
    { id: "9", title: "Logic", icon: 'brain' },
    { id: "10", title: "Math", icon: 'square-root-alt' },
    { id: "11", title: "Automotive", icon: 'car' },
    { id: "12", title: "Medicine", icon: 'heart' }
];